import { createSlice } from '@reduxjs/toolkit';
import { portalApi } from '../api/portalApi';

// Re-export RTK Query hook for direct component use
export { useGetChangeOrderDetailsQuery } from '../api/portalApi';

/**
 * Backward-compatible thunk wrapper.
 */
export const fetchAllChangeOrderDetails = () => (dispatch) => {
  return dispatch(
    portalApi.endpoints.getChangeOrderDetails.initiate(undefined, {
      forceRefetch: false,
    })
  );
};

const changeOrderDetailsSlice = createSlice({
  name: 'changeOrderDetailsGlobal',
  initialState: {
    data: [],
    loading: false,
    error: null,
    lastFetch: null,
  },
  reducers: {
    clearChangeOrderDetails: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.lastFetch = null;
    },
    setChangeOrderDetails: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ── RTK Query: getChangeOrderDetails ────────────────────────────────
      .addMatcher(
        portalApi.endpoints.getChangeOrderDetails.matchPending,
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )
      .addMatcher(
        portalApi.endpoints.getChangeOrderDetails.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.data = action.payload;
          state.lastFetch = new Date().toISOString();
        }
      )
      .addMatcher(
        portalApi.endpoints.getChangeOrderDetails.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error?.message ?? 'Failed to fetch change order details';
        }
      );
  },
});

export const { clearChangeOrderDetails, setChangeOrderDetails } = changeOrderDetailsSlice.actions;
export default changeOrderDetailsSlice.reducer;
